import { ISmevMonitoringIndex } from 'APIPackage/SmevMonitoringModule/interfaces/ISmevMonitoringIndex';
import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { SmevMonitoringServiceCell } from '../components/SmevMonitoringServiceCell';

export const initialSmevMonitoringTableColumns: ITableColumn<ISmevMonitoringIndex>[] = [
  {
    id: 'system',
    name: 'Система',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'service',
    name: 'Вид сведений',
    sort: TableColumnSortEnum.NONE,
    renderCell: SmevMonitoringServiceCell,
  },
  {
    id: 'endpoint',
    name: 'Эндпоинт',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'knmErpId',
    name: 'Номер КНМ',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'planId',
    name: 'Номер плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'receiveCreatedAt',
    name: 'Дата получения',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'sendCreatedAt',
    name: 'Дата отправки',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'smevCreatedAt',
    name: 'Дата получения ответа из СМЭВ',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'clientErrorCode',
    name: 'Код ошибки клиента',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'clientError',
    name: 'Ошибка клиента',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'processingStatus',
    name: 'Статус обработки',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'sendingStatus',
    name: 'Статус отправки',
    sort: TableColumnSortEnum.NONE,
  },
];
